export class FinancialDataServiceV1Impl {
    constructor(observer) {
        this.observer = observer;
    }
    subscribe(listener) {
        return this.observer.subscribe(listener);
    }
    update(newValue) {
        this.observer.update(newValue);
    }
    get() {
        return this.observer.value;
    }
}
